import React, { useEffect, useContext, useState } from 'react'
import './Widget.css'
import Divider from './Divider'
import AppContext from './AppContext';

function Widget({showLoading, id, style = {}, fill = true, title, viz, flushToBottom=true}) {

    const dataState = useContext(AppContext);
    const [loading, setLoading] = useState(true);
    const cf = window.cf

    if (!fill) {
        if (!style.background) style.background = 'transparent'
        style.boxShadow = 'none'
    }

    useEffect(() => {
        if(dataState.esError && showLoading) {
            setLoading(false);
        }
    }, [dataState.esError])

    useEffect(() => {
        viz()
            .element(id)
            .on('execute:stop', data => {
                if(showLoading) {
                    setLoading(false);
                    cf.getVisualization(id).resize();
                }
            })
            .execute()
            .catch(() => {
                setLoading(false);
                console.log(`There was an error with widget ${id}`)
            })
    }, [])

    return (
        <div id={`wc-${id}`} className={`widget`} style={style}>
            {fill && <div className="widget-header">{title}</div>}
            <Divider/>
            {showLoading && loading && <div className="widget-loading"> <div className="cf-wd-loader"/> </div>}
            {dataState.esError && <a className="ES-error">Error: No Living connections. Contact the site administrator</a>}
            {!dataState.esError && <div className={`${loading && showLoading?'':'widget-body'} ${flushToBottom? '':'flush-to-bottom'}`}
                    id={id}
                ></div>}
        </div>
    )
}

export default Widget
